import { render, staticRenderFns } from "./tablaenmalestado.vue?vue&type=template&id=608abd88&scoped=true"
import script from "./tablaenmalestado.vue?vue&type=script&lang=js"
export * from "./tablaenmalestado.vue?vue&type=script&lang=js"
import style0 from "./tablaenmalestado.vue?vue&type=style&index=0&id=608abd88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608abd88",
  null
  
)

export default component.exports